import { graphql, useStaticQuery } from 'gatsby';
import { Faq } from '@/types/cms-types';

export type UseFaqQuery = () => {
  items: Faq[];
};

export const useFaqQuery: UseFaqQuery = () => {
  const { allMicrocmsIpoServiceFaq } = useStaticQuery(
    graphql`
      query {
        allMicrocmsIpoServiceFaq(filter: { isTop: { eq: true } }) {
          nodes {
            ipoServiceFaqId
            question
            answer
            category
          }
        }
      }
    `,
  );

  return {
    items: allMicrocmsIpoServiceFaq.nodes as Faq[],
  };
};
